<<template>
  <div>
    <section class="blockElement banner Cmp_guide pb-0">
      <div class="container" align="center">
        <div class="banner_text text-center">
          <h1 class="m-0">
            A comprehensive guide for<br />
            Investing in<span> INDIA</span>
          </h1>
        </div>
        <img class="img-fluid" width="777" height="350"
          src="../../../../static/website/images/FPX-1.webp"
          alt="open_account_image"
        />
      </div>
    </section>
    <!--Section-->
    <section class="blockElement aboutUs pt-4">
      <div class="container">
        <div class="row text-center justify-content-center">
          <div class="col-11">
            <div class="bottom-shadow whiteBoard mt-5">
              <p>
                India has been attracting Foreign Portfolio Investors (FPIs,
                previously FIIs) from around the world because of its highly
                developed primary and secondary markets. All investments made by FPIs in India are regulated by the Securities and Exchange Board of India (SEBI) and facilitated by very few brokers in the country, with Shoonya being one of them.
              </p>
              <div class="customBtn-bt d-inline-block">
                <a
                  class="fin_btn darkBG"
                  href="http://fpiguide.com/"
                  target="_blank"
                  >Know More</a
                >
                <div class="animationArrow">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 209 117"
                    width="190"
                    height="100"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g clip-path="url(#animationMask_TYI245GuRS)">
                      <g
                        style="display: block"
                        transform="matrix(0.6139630675315857,0.26823386549949646,-0.26823386549949646,0.6139630675315857,120.114990234375,45.516510009765625)"
                        opacity="1"
                      >
                        <g opacity="1" transform="matrix(1.5,0,0,1.5,0,0)">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            fill-opacity="0"
                            stroke="rgb(51,51,51)"
                            stroke-opacity="1"
                            stroke-width="6"
                            d=" M-87.4000015258789,31.354999542236328 C-66.88099670410156,35.305999755859375 -37.04100036621094,39.92399978637695 -16.517000198364258,37.29199981689453 C40.516998291015625,29.979000091552734 34.388999938964844,-17.67099952697754 34.388999938964844,-17.67099952697754 C34.388999938964844,-17.67099952697754 33.35200119018555,-40.87300109863281 7.7779998779296875,-33.757999420166016 C-16.81399917602539,-26.91699981689453 -0.3619999885559082,4.229000091552734 -0.3619999885559082,4.229000091552734 C-0.3619999885559082,4.229000091552734 17.44700050354004,36.60599899291992 54.81999969482422,34.165000915527344 C71.677001953125,33.06399917602539 85.39600372314453,26.06999969482422 96.75499725341797,14.918999671936035"
                            class=""
                          ></path>
                        </g>
                      </g>

                      <g
                        style="display: block"
                        transform="matrix(-0.2974865436553955,0.6003347039222717,0.6003347039222717,0.2974865436553955,23.29077911376953,25.141700744628906)"
                        opacity="1"
                      >
                        <g opacity="1" transform="matrix(1.5,0,0,1.5,0,0)">
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            fill-opacity="0"
                            stroke="rgb(51,51,51)"
                            stroke-opacity="1"
                            stroke-width="6"
                            d=" M1.8020000457763672,21.783000946044922 C1.8020000457763672,21.783000946044922 9.711999893188477,3.072999954223633 9.711999893188477,3.072999954223633 C9.711999893188477,3.072999954223633 23.98200035095215,17.542999267578125 23.98200035095215,17.542999267578125"
                            class=""
                          ></path>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
            <div class="cta blob part" data-num="1">
              <img
                src="../../../../static/website/images/footer-blob1.svg"
                alt="Icon"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Section-->
    <section class="blockElement ps-timeline-sec fpiTimeline pb-4">
      <div class="container">
        <div class="head-title text-center">
          <h2>Type of <span>Investments</span> Allowed</h2>
        </div>
        <ol class="ps-timeline">
          <li>
            <div class="img-handler-top">
              <div class="apiNumber">EQUITY</div>
            </div>
            <div class="ps-bot">
              <h3 class="forMob">EQUITY</h3>
              <ul class="dotIcon text-left">
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Listed Equity
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Preference Shares
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Partly Paid Shares
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Units of Mutual Funds
                </li>
              </ul>
            </div>
            <span class="ps-sp-top">01</span>
          </li>
          <li>
            <div class="img-handler-bot">
              <div class="apiNumber">DEBT</div>
            </div>
            <div class="ps-top">
              <h3 class="forMob">DEBT</h3>
              <ul class="dotIcon text-left">
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Perpetual Debt Instruments such as Tier-I and upper Tier-II of
                  Bank Instruments
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Collective Investment Schemes
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Asset Reconstruction Companies (ARC)
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Security Receipts issued by ARC
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Securities Lending and Borrowing
                </li>
              </ul>
            </div>
            <span class="ps-sp-bot">02</span>
          </li>
          <li>
            <div class="img-handler-top">
              <div class="apiNumber">BONDS</div>
            </div>
            <div class="ps-bot">
              <h3 class="forMob">BONDS</h3>
              <ul class="dotIcon text-left">
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Dated Government Securities
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  State Development Loans
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Corporate Bonds – Non-Convertible
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Corporate Bonds – Convertible
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Credit Enhanced Bonds
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Municipal Bonds
                </li>
              </ul>
            </div>
            <span class="ps-sp-top">03</span>
          </li>
          <li>
            <div class="img-handler-bot">
              <div class="apiNumber">DERIVATIVE CONTRACTS</div>
            </div>
            <div class="ps-top">
              <h3 class="forMob">DERIVATIVE CONTRACTS</h3>
              <ul class="dotIcon text-left">
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Index Options
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Index Futures
                </li>

                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Stock Futures
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Stocks Options
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Interest Rate Futures
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Currency Futures
                </li>
                <li>
                  <check-icon size="1.5x" class="custom-class"></check-icon>
                  Currency Options
                </li>
              </ul>
            </div>
            <span class="ps-sp-bot">04</span>
          </li>
        </ol>
      </div>
    </section>
    <!--Section-->

    <section class="blockElement servc_offrd darkBG">
      <div class="container">
        <div class="head-title text-center mb-4">
          <h2>FPI<span> Registration </span> Process</h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-9">
            <ul class="dotIcon">
              <li>
                <check-icon size="1.5x" class="custom-class"></check-icon>
                Shoonya  will provide the Master Client Information forms for
                the FPI registration.
              </li>
              <li>
                <check-icon size="1.5x" class="custom-class"></check-icon>
                Appointed DDP (Designated Depository Participant) will create
                and complete registration for your PAN [Permanent Account
                Number] which will be issued by Indian Tax Department. The
                duration of the process will be a maximum of 14 days.
              </li>
              <li>
                <check-icon size="1.5x" class="custom-class"></check-icon> Once
                the PAN is issued, it will be submitted along with other
                documents for KYC and FPI Registration which will be processed
                within 3 days.
              </li>
              <li>
                <check-icon size="1.5x" class="custom-class"></check-icon> Bank
                account and DP (Depository Participant) account is set up, which
                can take between 5-8 days.
              </li>
              <li>
                <check-icon size="1.5x" class="custom-class"></check-icon> Once
                FPI registration is complete, you will be provided with CP
                [Custodial Participant] codes for equity and derivatives.
              </li>
              <li>
                <check-icon size="1.5x" class="custom-class"></check-icon>
                Lastly, a trading account is opened and the FPI is provided
                necessary logins for trading.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="blockElement servc_offrd">
      <div class="container" align="center">
        <div class="head-title text-center mb-4">
          <h2><span>Why</span> Shoonya for FPI?</h2>
        </div>
        <div class="row justify-content-center">
          <div class="col-12 col-md-10">
            <p>
            Shoonya is amongst India’s fastest growing FinTech company,
              offering brokerage services in equities, commodities and currency
              segments as well as depository and commercial clearing services.
              The company has advised institutional clients in fourteen
              countries on investments and acts as a one-stop shop for Foreign
              Portfolio Investors (FPI) who seek to invest in the Indian
              markets. Should you decide to set-up an FPI in India, you'll
              benefit from:
            </p>
            <div class="zeroFinancial">
              <div class="zeroFinancial-chart position-relative">
                <img
                  class="zeroImg img-fluid" width="300" height="407"
                  src="../../../../static/website/images/zerb-mob-5.webp"
                  alt="why shoonya" title="why shoonya"
                />
                <ul class="border-type-button">
                  <li class="tp">
                    <span
                      ><img
                        class="zeroCharges img-fluid"  
                        src="../../../../static/website/images/currency_derivatives_ico.svg"
                        width="60" height="42" alt="Annual fees" title="Annual fees"
                    /></span>
                    <span class="zeroContent">Zero</span> Annual fees
                  </li>
                  <li class="lp">
                    <span
                      ><img
                        class="zeroCharges img-fluid" 
                        src="../../../../static/website/images/currency_derivatives_ico.svg"
                        width="60" height="42" alt="AUM" title="AUM"
                    /></span>
                    <span class="zeroContent">Zero</span> AUM
                  </li>
                  <li class="rp">
                    <span
                      ><img
                        class="zeroCharges img-fluid" 
                        src="../../../../static/website/images/currency_derivatives_ico.svg"
                        width="60" height="42" alt="Brokerage" title="Brokerage"
                    /></span>
                    <span class="zeroContent">Zero</span> Brokerage on Delivery
                  </li>
                  <li class="bp">
                    <span
                      ><img
                        class="zeroCharges img-fluid" 
                        src="../../../../static/website/images/currency_derivatives_ico.svg"
                        width="60" height="42" alt="clearing charges" title="clearing charges"
                    /></span>
                    <span class="zeroContent">Zero</span> clearing charges
                  </li>
                  <li class="mp">
                    <span
                      ><img
                        class="zeroCharges img-fluid" 
                        src="../../../../static/website/images/currency_derivatives_ico.svg"
                        width="60" height="42" alt="Documentation fees" title="Documentation fees"
                    /></span>
                    <span class="zeroContent">Zero</span> Documentation fees
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="blockElement mobHide">
      <div class="container">
        <div class="head-title text-center">
          <h2>Platforms <span>Offered</span></h2>
        </div>
        <div class="finCustomTabs">
          <div class="row">
            <div class="col-12 col-md-5">
              <div
                class="nav flex-column nav-pills"
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
              >
                <ul class="tabs nav-tabs" id="myTab">
                  <li
                    class="nav-item"
                    v-for="tab in tabs"
                    @click.prevent="setActiveTabName(tab.name)"
                  >
                    <a
                      class="nav-link"
                      href="#"
                      v-bind:class="tab.name == activeTabName ? 'active' : ''"
                      >{{ tab.displayName }}</a
                    >
                  </li>
                </ul>
              </div>
            </div>
            <div class="col-12 col-md-7">
              <div
                class="text-left tab_container tab-content hideMob-t"
                id="myTabContent"
              >
                <h3
                  class="d_active tab_drawer_heading"
                  rel="tab1"
                  @click.prevent="setActiveTabName('overview')"
                  v-bind:class="activeTabName == 'overview' ? 'active' : ''"
                >
                  Co-Location Services
                </h3>
                <div
                  id="tab1"
                  class="tab_content"
                  v-if="activeTabName == 'overview'"
                >
                  <div class="bottom-shadow whiteBoard">
                    <p>
                      Colocation services enable you to access ultra-low latency
                      market data, connectivity and application hosting services
                      in close proximity to the exchanges.
                    </p>
                    <ul class="dotIcon">
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Deploy latency sensitive trading strategies
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Enhanced Market connectivity
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Remote access to your trading applications
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Enterprise-class security
                      </li>
                    </ul>
                  </div>
                  <div class="cta blob part" data-num="1">
                    <img
                      src="../../../../static/website/images/footer-blob1.svg"
                      alt="Icon"
                    />
                  </div>
                </div>
                <!-- #tab1 -->
                <h3
                  class="tab_drawer_heading"
                  rel="tab2"
                  @click.prevent="setActiveTabName('about')"
                  v-bind:class="activeTabName == 'about' ? 'active' : ''"
                >
                  Algo & HFT Solutions
                </h3>
                <div
                  id="tab2"
                  class="tab_content"
                  v-if="activeTabName == 'about'"
                >
                  <div class="bottom-shadow whiteBoard">
                    <p>
                      Our ALGO/HFT solutions allow users to Prototype and Back
                      test new strategies that support all asset classes. For
                      better performance we have installed Dedicated Servers,
                      Co-location servers, Data Centre and well experienced in
                      house ALGO developers
                    </p>
                  </div>
                  <div class="cta blob part" data-num="1">
                    <img
                      src="../../../../static/website/images/footer-blob1.svg"
                      alt="Icon"
                    />
                  </div>
                </div>
                <!-- #tab2 -->
                <h3
                  class="tab_drawer_heading"
                  rel="tab3"
                  @click.prevent="setActiveTabName('check')"
                  v-bind:class="activeTabName == 'check' ? 'active' : ''"
                >
                  Latency API
                </h3>
                <div
                  id="tab3"
                  class="tab_content"
                  v-if="activeTabName == 'check'"
                >
                  <div class="bottom-shadow whiteBoard">
                    <p>
                      API model with advanced development features that allows
                      programmers to develop, test and deploy proprietary
                      trading strategies faster than you thought and scale it to
                      many markets. The features of latency sensitive APIs are:
                    </p>
                    <ul class="dotIcon">
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Unprecedented Trading Performance
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Accelerated Order sending
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        User Friendly Interface
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Pre-Trade Risk Check
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Predefined Statistics Computations
                      </li>
                      <li>
                        <check-icon
                          size="1.5x"
                          class="custom-class"
                        ></check-icon>
                        Trading Strategies Implementation
                      </li>
                    </ul>
                  </div>
                  <div class="cta blob part" data-num="1">
                    <img
                      src="../../../../static/website/images/footer-blob1.svg"
                      alt="Icon"
                    />
                  </div>
                </div>

                <!-- #tab3 -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <app-seo></app-seo>
    </section>
    <section class="blockElement position-relative">
      <div class="container">
        <div class="head-title text-center">
          <h2>Get in <span>Touch</span></h2>
        </div>
        <div class="row align-items-center">
          <div class="col-12 col-md-6">
            <div class="getIn-imag">
              <img class="img-fluid" width="432" height="385"
                src="../../../../static/website/images/4111240.svg"
                alt="get in touch" title="get in touch"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <appgetinTouch :page="'fpi'"></appgetinTouch>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import SEO from "../shared/SEO";
import VueFaqAccordion from "vue-faq-accordion";
import { CheckIcon } from "vue-feather-icons";
import getinTouch from "../shared/contactform/getintouch";
export default {
  name: "FPI",
  data() {
    return {
      prismRegisterPath: process.env.PRISM_REGISTER,
      tabs: [
        {
          name: "overview",
          displayName: "Co-Location Services ",
        },
        {
          name: "about",
          displayName: "Algo & HFT Solutions",
        },
        {
          name: "check",
          displayName: "Latency Sensitive API",
        },
      ],
      activeTabName: null,
    };
  },
  components: {
    VueFaqAccordion,
    appSeo: SEO,
    CheckIcon,
    appgetinTouch: getinTouch,
  },
  methods: {
    setActiveTabName(name) {
      this.activeTabName = name;
    },
  },
  mounted() {
    this.activeTabName = this.tabs[0].name;
    window.scroll(0, 0);
  },
};
</script>
>


// WEBPACK FOOTER //
// src/components/website/products/fpi_services.vue